"use strict";

exports.__esModule = true;
exports["default"] = splitWrapperAndElementProps;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _object = _interopRequireDefault(require("object.omit"));

var _htmlAttributesAllowlistProps = _interopRequireDefault(require("./htmlAttributesAllowlistProps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// For components that are wrapped in an html element such as a div
// some props should be passed to the element that is wrapped and
// some props should be passed to the wrapper element
function splitWrapperAndElementProps(props, element) {
  var elementProps = (0, _htmlAttributesAllowlistProps["default"])(element, props);
  var omittedProps = Object.keys(elementProps);
  var wrapperProps = (0, _object["default"])(props, omittedProps);
  return [wrapperProps, elementProps];
}